import Link from '../../views/ResetPassword';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { actions } from '../../../state/assessment';

const mapStateToProps = (state, ownProps) => ({
  intel: ownProps.match.params.intel,
  locale: ownProps.match.params.locale,
  status: state.shift.status,
  username: state.shift.auth.username,
  gitlab_id: state.shift.auth.gitlab_id
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const { locale } = ownProps.match.params;

  return {
    clickLoginHandler: value => {
      //console.log(value);
      dispatch(push(`/${locale}/login`));
    },

    updatePassword: (gitlabid, username) =>
      dispatch(actions.updatePassword((gitlabid, username)))
  };
};

const ResetPassword = connect(
  mapStateToProps,
  mapDispatchToProps
)(Link);

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/components/container/ResetPassword/index.js